import * as React from "react";

import { SvgIconProps } from "@material-ui/core/SvgIcon";
import FlightLandTwoTone from "@material-ui/icons/FlightLandTwoTone";
import FlightTakeoffTwoTone from "@material-ui/icons/FlightTakeoffTwoTone";
import LocalShippingTwoTone from "@material-ui/icons/LocalShippingTwoTone";
import MarkunreadMailboxTwoTone from "@material-ui/icons/MarkunreadMailboxTwoTone";
import UnarchiveTwoTone from "@material-ui/icons/UnarchiveTwoTone";
import { WithTranslation, withTranslation } from "react-i18next";
import { ShipmentState } from "~/components/TrackTrace/types";
import styled from "~/styled";
import { ProgressItem, StepState } from "./ProgressItem";

interface IProps {
  state: ShipmentState;
}

interface IStep {
  status: StepState;
  shipmentState: ShipmentState;
  icon: React.ComponentType<SvgIconProps>;
  title: string;
}

const ProgressBarWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
  grid-column-gap: 24px;
  margin-top: 24px;

  @media (max-width: 568px) {
    grid-template-columns: none;
  }
`;

class ShipmentProgressbar extends React.Component<IProps & WithTranslation> {
  public render() {
    const { t, state } = this.props;

    const steps: IStep[] = this.mapSteps(state, [
      {
        icon: UnarchiveTwoTone,
        shipmentState: ShipmentState.PROCESSING,
        status: StepState.PENDING,
        title: t("status.processing")
      },
      {
        icon: FlightTakeoffTwoTone,
        shipmentState: ShipmentState.DEPART_ORIGIN_COUNTRY,
        status: StepState.PENDING,
        title: t("status.departOriginCountry")
      },
      {
        icon: FlightLandTwoTone,
        shipmentState: ShipmentState.ARRIVE_DESTINATION_COUNTRY,
        status: StepState.PENDING,
        title: t("status.arriveDestinationCountry")
      },
      {
        icon: LocalShippingTwoTone,
        shipmentState: ShipmentState.LOCAL_SHIPPING_PROVIDER,
        status: StepState.PENDING,
        title: t("status.localShippingProvider")
      },
      {
        icon: MarkunreadMailboxTwoTone,
        shipmentState: ShipmentState.DELIVERY,
        status: StepState.PENDING,
        title: t("status.delivery")
      }
    ]);

    return (
      <ProgressBarWrapper>
        {steps.map(({ icon, title, shipmentState, status }) => (
          <ProgressItem
            key={shipmentState}
            status={status}
            icon={icon}
            title={title}
          />
        ))}
      </ProgressBarWrapper>
    );
  }

  private mapSteps(
    currentShipmentState: ShipmentState,
    steps: IStep[]
  ): IStep[] {
    const activeStepIndex = steps.findIndex(
      step => step.shipmentState === currentShipmentState
    );

    const activeStep = { ...steps[activeStepIndex], status: StepState.ACTIVE };
    const doneSteps = steps
      .slice(0, activeStepIndex)
      .map(step => ({ ...step, status: StepState.DONE }));
    const pendingSteps = steps
      .slice(activeStepIndex + 1, steps.length)
      .map(step => ({ ...step, status: StepState.PENDING }));

    return [...doneSteps, activeStep, ...pendingSteps];
  }
}

export default withTranslation("trackTrace")(ShipmentProgressbar);



// WEBPACK FOOTER //
// ./src/components/TrackTrace/ShipmentProgressbar.tsx